import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';

interface RoomModalFooterProps {
  onSubmit: () => void;
  hideModal: () => void;
  title: string;
}

export const RoomModalFooter = ({ onSubmit, hideModal, title }: RoomModalFooterProps) => {
  return (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>{title}</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );
};
